exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/my-dream-app/src/app/process-plant-uptime-calculator/process-plant-uptime-calculator.component.css
// module id = ../../../../../src/app/process-plant-uptime-calculator/process-plant-uptime-calculator.component.css
// module chunks = main